import { FaMapMarkerAlt, FaRegTrashAlt } from 'react-icons/fa';
import { InferType, object, ObjectSchema, string } from 'yup';

import { CreateInvestmentSpacePayload, SpaceReadModel } from '@client/api';
import { Button, isDefinedString, TableCell, TableRow, Text } from '@client/toolkit';

type FormModel = CreateInvestmentSpacePayload;

const schema: ObjectSchema<FormModel> = object({
  spaceId: string().required(),
  priceId: string().nullable(),
});

type FormValues = InferType<typeof schema>;

export const investmentSpaceCreateSchema = schema;
export type InvestmentSpaceCreateFormData = FormValues;

interface InvestmentSpaceItemCreateFormProps {
  fieldIndex: number;
  space?: SpaceReadModel;
  onRemove?: (fieldIndex: number) => void;
}

export function InvestmentSpaceItemCreateForm({ fieldIndex, space, onRemove }: InvestmentSpaceItemCreateFormProps) {
  return (
    <TableRow verticalAlign="middle">
      <TableCell>
        <div className="flex items-center justify-end">
          <div className="flex-1 overflow-hidden text-ellipsis">
            <Text as="div" isEmpty={!isDefinedString(space?.name)}>
              <strong className="whitespace-nowrap font-medium">{space?.name}</strong>
            </Text>
            <div className="flex items-center overflow-hidden">
              <FaMapMarkerAlt className="text-xs text-red-600 inline mr-1 -mt-1 -mb-1" />
              <Text
                as="div"
                className="text-xs font-normal text-secondary flex-1 whitespace-nowrap"
                isEmpty={!isDefinedString(space?.address?.formattedAddress)}
              >
                {space?.address?.formattedAddress}
              </Text>
            </div>
          </div>
          <Button
            className="ml-2"
            size="xs"
            color="secondary-light"
            disabled={typeof onRemove !== 'function'}
            onClick={() => {
              if (typeof onRemove !== 'function') {
                return;
              }
              onRemove(fieldIndex);
            }}
          >
            <FaRegTrashAlt />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
}
